import Box, { BoxProps } from '@mui/material/Box'

// Enforce the id prop to be required
interface MaestroBoxProps extends Omit<BoxProps, 'id'> {
  id: string
}

/**
 * Component used to instrument the code with and
 * id used by Maestro testing tool selectors.
 */
export const MaestroBox = ({ id, ...props }: MaestroBoxProps) => {
  const maestroId = `maestro-${id}`

  return <Box {...props} id={maestroId} />
}
